module.exports = __webpack_public_path__ + "img/ykb.e6c54a61.png";